import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-486243e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "free-poker-header" }, [
  /*#__PURE__*/_createElementVNode("h1", null, [
    /*#__PURE__*/_createTextVNode("Scrum poker made simple and "),
    /*#__PURE__*/_createElementVNode("span", null, "free"),
    /*#__PURE__*/_createTextVNode(".")
  ])
], -1))
const _hoisted_4 = { class: "start-game" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  version: "1.1",
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  width: "24px",
  height: "30px",
  viewBox: "0 0 24 30",
  style: {"enable-background":"new 0 0 50 50"},
  "xml:space": "preserve"
}
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<rect x=\"0\" y=\"10\" width=\"4\" height=\"10\" fill=\"#333\" opacity=\"0.2\" data-v-486243e4><animate attributeName=\"opacity\" attributeType=\"XML\" values=\"0.2; 1; .2\" begin=\"0s\" dur=\"0.6s\" repeatCount=\"indefinite\" data-v-486243e4></animate><animate attributeName=\"height\" attributeType=\"XML\" values=\"10; 20; 10\" begin=\"0s\" dur=\"0.6s\" repeatCount=\"indefinite\" data-v-486243e4></animate><animate attributeName=\"y\" attributeType=\"XML\" values=\"10; 5; 10\" begin=\"0s\" dur=\"0.6s\" repeatCount=\"indefinite\" data-v-486243e4></animate></rect><rect x=\"8\" y=\"10\" width=\"4\" height=\"10\" fill=\"#333\" opacity=\"0.2\" data-v-486243e4><animate attributeName=\"opacity\" attributeType=\"XML\" values=\"0.2; 1; .2\" begin=\"0.15s\" dur=\"0.6s\" repeatCount=\"indefinite\" data-v-486243e4></animate><animate attributeName=\"height\" attributeType=\"XML\" values=\"10; 20; 10\" begin=\"0.15s\" dur=\"0.6s\" repeatCount=\"indefinite\" data-v-486243e4></animate><animate attributeName=\"y\" attributeType=\"XML\" values=\"10; 5; 10\" begin=\"0.15s\" dur=\"0.6s\" repeatCount=\"indefinite\" data-v-486243e4></animate></rect><rect x=\"16\" y=\"10\" width=\"4\" height=\"10\" fill=\"#333\" opacity=\"0.2\" data-v-486243e4><animate attributeName=\"opacity\" attributeType=\"XML\" values=\"0.2; 1; .2\" begin=\"0.3s\" dur=\"0.6s\" repeatCount=\"indefinite\" data-v-486243e4></animate><animate attributeName=\"height\" attributeType=\"XML\" values=\"10; 20; 10\" begin=\"0.3s\" dur=\"0.6s\" repeatCount=\"indefinite\" data-v-486243e4></animate><animate attributeName=\"y\" attributeType=\"XML\" values=\"10; 5; 10\" begin=\"0.3s\" dur=\"0.6s\" repeatCount=\"indefinite\" data-v-486243e4></animate></rect>", 3)
const _hoisted_10 = [
  _hoisted_7
]

import router from "@/router";
import {io} from "socket.io-client";
import {ref} from 'vue';
import {useGameEngine} from "@/composables/useGameEngine";
import GameFormat from "@/view-models/gameFormat";


export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const {socket, setSocket} = useGameEngine();
const clickedStart = ref(false);
const hasStarted = ref(false);

function startGame() {
  clickedStart.value = true;
  setTimeout(() => {
    if (!hasStarted.value) {
      alert("Looks like there's a problem connecting you to the server 😕");
    }
  }, 6000);
  registerSocket();
}

function registerSocket() {
  const newSocket = io(process.env.VUE_APP_SERVER);
  setSocket(newSocket);
  socket.value.on("room", (roomId: string) => {
    hasStarted.value = true;
    router.push({path: `/game/${roomId}`});
  });
  socket.value.on("gameTypes", (gameTypes: GameFormat[]) => {
    localStorage.setItem("gameTypes", JSON.stringify(gameTypes));
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: _normalizeClass(["button", { disabled: clickedStart.value }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (startGame()))
        }, [
          (!clickedStart.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Create room"))
            : _createCommentVNode("", true),
          (clickedStart.value)
            ? (_openBlock(), _createElementBlock("svg", _hoisted_6, _hoisted_10))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ])
  ]))
}
}

})